import { randUuid } from '@ngneat/falso';
import { immerable } from 'immer';
import { Set } from 'immutable';

import { ColumnConfigItemEntity } from './column-config-item.entity';
import { ColumnStatus } from './subscription.types';

interface IColumnModelItemEntity {
	id: string;
	label: string;
	description: string;
	columns: Set<ColumnConfigItemEntity>;
	linkedProfileIds: Set<string>;
	status: ColumnStatus;
	isInSync: boolean;
}

const entityDefaults: IColumnModelItemEntity = {
	id: '-1',
	label: '',
	description: '',
	columns: Set(),
	linkedProfileIds: Set(),
	status: ColumnStatus.None,
	isInSync: false,
};

export class ColumnModelItemEntity implements IColumnModelItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public description = entityDefaults.description;
	public columns = entityDefaults.columns;
	public linkedProfileIds = entityDefaults.linkedProfileIds;
	public status = entityDefaults.status;
	public isInSync = entityDefaults.isInSync;

	public static build(
		params: Partial<IColumnModelItemEntity> = {}
	): ColumnModelItemEntity {
		const instance = new ColumnModelItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.label = params.label ?? entityDefaults.label;
		instance.description = params.description ?? entityDefaults.description;
		instance.columns = params.columns ?? entityDefaults.columns;
		instance.linkedProfileIds =
			params.linkedProfileIds ?? entityDefaults.linkedProfileIds;
		instance.status = params.status ?? entityDefaults.status;
		instance.isInSync = params.isInSync ?? entityDefaults.isInSync;

		return instance;
	}

	public static createDefaultColumnModel(
		columns: Set<ColumnConfigItemEntity>
	): ColumnModelItemEntity {
		return new ColumnModelItemEntity({
			id: randUuid(),
			label: $localize`:i18n=@@subscription.columnModel.default.label:`,
			description: '',
			columns,
			linkedProfileIds: Set(),
			status: ColumnStatus.None,
		});
	}
	public constructor(params: Partial<ColumnModelItemEntity> = {}) {
		this.id = params.id ?? entityDefaults.id;
		this.label = params.label ?? entityDefaults.label;
		this.description = params.description ?? entityDefaults.description;
		this.columns = params.columns ?? entityDefaults.columns;
		this.linkedProfileIds =
			params.linkedProfileIds ?? entityDefaults.linkedProfileIds;
		this.status = params.status ?? entityDefaults.status;
	}

	public isColumnsEqual(columns: Set<ColumnConfigItemEntity>): boolean {
		if (this.columns.size !== columns.size) {
			return false;
		}

		return this.columns.toArray().every((item) => {
			const col = columns.toArray().find((c) => c.id === item.id);
			return !!col && col.isHashed === item.isHashed;
		});
	}
}
